import api from "../config/api";

export const getContractInvocies = async (data) => {
  const res = await api.post("contractInvoice/getContractInvocies", data);
  return res.data;
};

export const getIncompleteInvoiceIds = async (data) => {
  const res = await api.get("contractInvoice/incompleteInvoiceIds", data);
  return res.data;
};

export const getContInvByContractId = async (data) => {
  const res = await api.get("contractInvoice/getContInvByContractId", data);
  return res.data;
};

export const getContractInvocieByid = async (_id) => {
  const res = await api.get("contractInvoice", { _id });
  return res.data;
};
